import { Component, Input, TemplateRef, OnInit, Inject, HostListener, EventEmitter } from '@angular/core';
import { AnimationEvent, animate, style, transition, trigger, state } from '@angular/animations';
import { PopoverContent } from './popover-content';
import { POPOVER_CONTENT_DATA } from './popover.tokens';
import { PopoverRef } from './popover-ref';

const ESCAPE_KEY = 27;
const POPOVER_ANIMATION_TIMINGS = '200ms cubic-bezier(0.64, 0, 0.35, 1)';

@Component({
  selector: 'suka-popover',
  template: `
    <div
      [@popover]="animationState"
      (@popover.start)="onAnimationStart($event)"
      (@popover.done)="onAnimationDone($event)"
      cdkTrapFocus
      class="popover popover-{{position}}"
      role="dialog"
    >
      <suka-popover-section
        *ngIf="(sectioned !== false)
        else elseTpl"
      >
        <ng-container *ngTemplateOutlet="elseTpl"></ng-container>
      </suka-popover-section>
    </div>

    <ng-template #elseTpl>
      <ng-container [ngSwitch]="renderMethod">
        <div *ngSwitchCase="'text'" [innerHTML]="content.body"></div>
        <ng-container *ngSwitchCase="'template'">
          <ng-container *ngTemplateOutlet="content.body; context: {closePopover: closePopover.bind(this)}"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'component'">
          <ng-container *ngComponentOutlet="content.body"></ng-container>
        </ng-container>
      </ng-container>
    </ng-template>
    `,
  animations: [
    trigger('popover', [
      state('void', style({ transform: 'scale(.9)', opacity: 0 })),
      state('enter', style({ transform: 'none', opacity: 1 })),
      state('leave', style({ transform: 'scale(.8)', opacity: 0 })),
      transition('* => *', animate(POPOVER_ANIMATION_TIMINGS)),
    ]),
  ],
})
export class PopoverContainer implements OnInit {
  public animationState: 'void' | 'enter' | 'leave' = 'enter';
  public animationStateChanged = new EventEmitter<AnimationEvent>();

  public renderMethod: 'template' | 'component' | 'text' = 'component';

  @Input() position: 'top' | 'bottom' | 'right' | 'left' = 'bottom';
  @Input() sectioned = false;

  constructor(
    public popoverRef: PopoverRef,
    @Inject(POPOVER_CONTENT_DATA) public content: PopoverContent
  ) {}

  ngOnInit() {
    if (typeof this.content.body === 'string') {
      this.renderMethod = 'text';
    }

    if (this.content.body instanceof TemplateRef) {
      this.renderMethod = 'template';
    }

    if (this.content.sectioned) {
      this.sectioned = true;
    }
  }

  closePopover($event: any) {
    this.popoverRef.close($event);
  }

  @HostListener('document:keydown', ['$event']) public handleKeydown(event: KeyboardEvent) {
    // tslint:disable-next-line: deprecation
    if (event.keyCode === ESCAPE_KEY) {
      this.popoverRef.close();
    }
  }

  onAnimationStart(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  onAnimationDone(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  startExitAnimation() {
    this.animationState = 'leave';
  }
}
